<div class="shell" [class.sidebar-collapsed]="sidebarCollapsed">

  <!-- ── Mobile backdrop ──────────────────────────────────────────────────── -->
  <div class="mobile-backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu()"></div>

  <!-- ── Sidebar ──────────────────────────────────────────────────────────── -->
  <aside class="sidebar" [class.collapsed]="sidebarCollapsed" [class.mobile-open]="mobileMenuOpen">

    <!-- Logo -->
    <div class="sidebar-logo">
      <a routerLink="/dashboard" class="logo-link" aria-label="JCI Nusantara home">
        <img
          *ngIf="!logoLoadFailed"
          [src]="brandLogoUrl"
          alt="JCI Nusantara"
          class="logo-img"
          (error)="onLogoError()"
        />
        <span *ngIf="logoLoadFailed" class="logo-fallback">J</span>
      </a>
      <button
        class="collapse-toggle"
        type="button"
        (click)="toggleSidebar()"
        [attr.aria-label]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      >
        <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
          <path
            [attr.d]="sidebarCollapsed ? 'M9 18l6-6-6-6' : 'M15 18l-6-6 6-6'"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Search -->
    <div class="sidebar-search-wrap" *ngIf="!sidebarCollapsed">
      <label class="sidebar-search">
        <svg viewBox="0 0 24 24" fill="none" width="13" height="13" class="search-icon">
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
          <path d="m21 21-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <input type="text" placeholder="Search menu…" [(ngModel)]="sidebarFilter" />
      </label>
    </div>

    <!-- Nav -->
    <nav class="sidebar-nav" aria-label="Main navigation">
      <ng-container *ngFor="let item of filteredNavItems">

        <!-- Section label -->
        <p class="nav-section-label" *ngIf="item.sectionLabel && !sidebarCollapsed">
          {{ item.sectionLabel }}
        </p>

        <div class="nav-item-wrap" [attr.data-nav-section]="item.key">

          <!-- Parent with children -->
          <button
            *ngIf="item.children?.length; else directLink"
            type="button"
            class="nav-item"
            [class.active]="isItemActive(item)"
            [attr.title]="sidebarCollapsed ? item.label : null"
            (click)="toggleSection(item.key)"
          >
            <span class="nav-icon-wrap">
              <svg class="nav-icon" viewBox="0 0 24 24" fill="none">
                <path [attr.d]="iconPath(item.icon)" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="nav-label" *ngIf="!sidebarCollapsed">{{ item.label }}</span>
            <span class="soon-badge" *ngIf="!sidebarCollapsed && item.comingSoon">Soon</span>
            <svg
              *ngIf="!sidebarCollapsed"
              class="nav-chevron"
              [class.open]="isSectionOpen(item.key)"
              viewBox="0 0 24 24" fill="none" width="13" height="13"
            >
              <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <!-- Subnav -->
          <div
            class="subnav"
            *ngIf="item.children?.length && isSectionOpen(item.key) && !sidebarCollapsed"
          >
            <ng-container *ngFor="let child of item.children">

              <!-- Direct child link -->
              <a
                *ngIf="child.path; else groupChild"
                [routerLink]="child.path"
                routerLinkActive="active"
                class="subnav-item"
                (click)="closeMobileMenu()"
              >
                <span>{{ child.label }}</span>
                <span class="soon-badge" *ngIf="child.comingSoon">Soon</span>
              </a>

              <!-- Child group (no path, has grandchildren) -->
              <ng-template #groupChild>
                <button
                  type="button"
                  class="subnav-group"
                  (click)="toggleChildSection(child.key)"
                >
                  <span>{{ child.label }}</span>
                  <svg
                    class="nav-chevron"
                    [class.open]="isChildSectionOpen(child.key)"
                    viewBox="0 0 24 24" fill="none" width="11" height="11"
                  >
                    <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2.2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <ng-container *ngIf="isChildSectionOpen(child.key)">
                  <a
                    *ngFor="let gc of child.children || []"
                    [routerLink]="gc.path"
                    routerLinkActive="active"
                    class="subnav-item subnav-item--l2"
                    (click)="closeMobileMenu()"
                  >
                    <span>{{ gc.label }}</span>
                    <span class="soon-badge" *ngIf="gc.comingSoon">Soon</span>
                  </a>
                </ng-container>
              </ng-template>

            </ng-container>
          </div>

          <!-- Direct link (no children) -->
          <ng-template #directLink>
            <a
              [routerLink]="item.path"
              routerLinkActive="active"
              class="nav-item"
              [attr.title]="sidebarCollapsed ? item.label : null"
              (click)="closeMobileMenu()"
            >
              <span class="nav-icon-wrap">
                <svg class="nav-icon" viewBox="0 0 24 24" fill="none">
                  <path [attr.d]="iconPath(item.icon)" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="nav-label" *ngIf="!sidebarCollapsed">{{ item.label }}</span>
              <span class="soon-badge" *ngIf="!sidebarCollapsed && item.comingSoon">Soon</span>
            </a>
          </ng-template>

        </div>
      </ng-container>
    </nav>

    <!-- Footer: user + logout -->
    <div class="sidebar-footer">
      <div class="sidebar-user" *ngIf="!sidebarCollapsed">
        <div class="user-avatar">{{ displayName.charAt(0).toUpperCase() }}</div>
        <div class="user-info">
          <span class="user-name">{{ displayName }}</span>
          <span class="user-role">Officer</span>
        </div>
      </div>
      <button
        class="logout-btn"
        type="button"
        (click)="logout()"
        [attr.title]="sidebarCollapsed ? 'Log out' : null"
      >
        <svg viewBox="0 0 24 24" fill="none" width="15" height="15">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 17l5-5-5-5m5 5H9" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span *ngIf="!sidebarCollapsed">Log out</span>
      </button>
    </div>

  </aside>

  <!-- ── Main content ──────────────────────────────────────────────────────── -->
  <div class="shell-main">

    <!-- Topbar -->
    <header class="topbar">
      <div class="topbar-left">
        <button class="mobile-menu-btn" type="button" (click)="toggleMobileMenu()" aria-label="Open menu">
          <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
            <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="topbar-right">
        <div class="topbar-user">
          <div class="topbar-avatar">{{ displayName.charAt(0).toUpperCase() }}</div>
          <span class="topbar-name">{{ displayName }}</span>
        </div>
      </div>
    </header>

    <!-- Page content -->
    <div class="page-frame">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>
